module.exports = __webpack_public_path__ + "img/hr-dead-grey-trunk-04.84fe661f.png";